import { forwardRef, useCallback, useEffect, useMemo, useState } from 'react';
import { Snackbar as MuiSnackbar } from '@mui/material';
import { SnackbarContent } from './SnackbarContent';
import { mergeSxStyle } from '../../common/mergeSxStyle';
import { jsx as _jsx } from "react/jsx-runtime";
const resolveAnchorOrigin = position => {
  if (position === 'bottom-center') {
    return {
      vertical: 'bottom',
      horizontal: 'center'
    };
  }
  if (position === 'top-center') {
    return {
      vertical: 'top',
      horizontal: 'center'
    };
  }
};
export const Snackbar = /*#__PURE__*/forwardRef((_ref, ref) => {
  let {
    show,
    message,
    position,
    autoHide = true,
    type = 'default',
    className,
    action,
    onClose,
    id,
    ...rest
  } = _ref;
  const [_show, setShow] = useState(false);
  useEffect(() => {
    setShow(show);
  }, [show]);
  const anchorOrigin = useMemo(() => resolveAnchorOrigin(position), [position]);
  const handleOnClose = useCallback((event, reason) => {
    if (reason === 'clickaway') {
      return;
    }
    setShow(false);
    if (onClose) {
      onClose(event, reason);
    }
  }, []);
  return /*#__PURE__*/_jsx(MuiSnackbar, {
    open: _show,
    anchorOrigin: anchorOrigin,
    autoHideDuration: autoHide === true ? 5000 : undefined,
    onClose: handleOnClose,
    className: className,
    id: id,
    "data-testid": rest['data-testid'],
    sx: mergeSxStyle({}, []),
    children: /*#__PURE__*/_jsx("div", {
      children: /*#__PURE__*/_jsx(SnackbarContent, {
        message: message,
        type: type,
        action: action,
        onClose: handleOnClose,
        id: id,
        "data-testid": rest['data-testid']
      })
    })
  });
});
Snackbar.displayName = 'Snackbar';